import React from "react";
import "./../../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../../Styles/app.css";
import "./Styles/style.css";
import "./Styles/theme-responsive.css";
import { connect } from "react-redux";
import { RegisterFooter, RegisterHeader } from "../../CommonComponents";
import "../../../../node_modules/font-awesome/css/font-awesome.min.css";
import Success from "../../assets/registerImages/successImage.svg";
import RingLoader from "react-spinners/ClipLoader";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  completeRegisterUser,
  completeRegisterUserClear,
  getUserInformation,
  getUserInfoClear,
  loginRegisteredUser, showModal, hideModal, setHelpList
} from "../../../common/actions/userAccount";
import GLOBAL_CONST from '../../../helper/AppConstants';
import { withTranslation } from "react-i18next";
import { createLoadingSelector } from "../../../common/reducers/selectors";
const loadingSelector = createLoadingSelector(["complete_registration_user"]);
toast.configure();

class RegisterSuccess extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalVisible: false,
      isRegistered: false,
      message: "",
    };
    this.dosetHelpList()
    this.getUserDetails();
  }

  dosetHelpList = () => {
    this.props.dosetHelpList({
      stackType: "Registration",
      screen: GLOBAL_CONST.SCREEN_NAMES.REGISTRATION_SUCCESS,
      title: this.props.t('regCardScr-regAccount'),
    });
  }
  openHelpModal = () => {
    this.props.doShowModal({
      modalScreenName: "HelpListing",
      modalClassName: "helpSupportModal sidebar-modal right",
      params: {
        stackType: this.props.setHelpListData.stackType,
        screen: this.props.setHelpListData.screen,
        title: this.props.setHelpListData.title,
      }
    });
  }


  submitForm = () => {
    const { doCompleteRegisterUser, registeredPassword } = this.props;
    doCompleteRegisterUser({
      Password: registeredPassword,
    });
  };
  getUserDetails = () => {
    const { doGetUserInformation } = this.props;
    doGetUserInformation();
  };

  doNavigation = (isParent, isDelegate) => {
    const { completeRegisterUserResponse, doLoginRegisteredUser } = this.props;
    doLoginRegisteredUser(completeRegisterUserResponse.LoggedInParentInfo);
    if (isParent || isDelegate) {
      this.props.history.push("/childManagement");
    } else {
      this.props.history.push("/chooseRole");
    }
    getUserInfoClear();
  };

  render() {
    const {
      getUserInfoResponse,
      completeRegisterUserResponse,
      isFetching,
      error,
      doCompleteRegisterUserClear,
      registeredFirstname,
    } = this.props;

    const { isRegistered } = this.state;
    let message = "",
      title = "";
    let isParent = false,
      isDelegate = false;
    if (getUserInfoResponse && getUserInfoResponse.Data.KidsAtSchools > 0) {
      isParent = true;
    }
    if (
      getUserInfoResponse &&
      getUserInfoResponse.Data.KidsDelegatedCurrently > 0
    ) {
      isDelegate = true;
    }

    if (isParent) {
      title = `${this.props.t(
        "regSuccessScr-messageCongrats"
      )} ${registeredFirstname}`;
      message = this.props.t("regSuccessScr-messageParent");
    } else if (isDelegate) {
      title = `${this.props.t(
        "regSuccessScr-messageCongrats"
      )} ${registeredFirstname}`;
      message = this.props.t("regSuccessScr-messageDelegate");
    } else {
      title = `${this.props.t(
        "regSuccessScr-messageGreeting"
      )} ${registeredFirstname}`;
      message = this.props.t("regSuccessScr-messageHi");
    }
    if (error) {
      toast.error(error.Message || error.message, { autoClose: 2000 });

      doCompleteRegisterUserClear();
    } else if (completeRegisterUserResponse && isRegistered === false) {
      this.setState({ isRegistered: true }, () => {
        this.doNavigation(isParent, isDelegate);
      });
    }
    return (
      <section className="registration">
        <div className="wrapper">
          <div className="landing-wrapper">
            <div className="row h-100vh nomargin-row">
              <RegisterHeader />
              <div className="col-sm-12 col-md-5 col-lg-5 col-xl-4 sidebar-col">
                <div className="sidebar-wrapper">
                  <form className="form-style1">
                    {/* <div className="nav-buttons">
                      <a href="/" className="close-btn"></a>
                    </div> */}
                    <div>
                      <img src={Success} alt="PikMyKid" title="PikMyKid" />
                    </div>
                    {/* {isFetching &&
                      <div className="loaderHolder mt-60">
                        <RingLoader color="#3fa9f5" loading={isFetching} size={60} />
                      </div>
                    } */}
                    <div className="title-sect mb-40" style={{ marginTop: 30 }}>
                      <h3 className="title-3">{title}</h3>
                      <p className="helptext">{message}</p>
                    </div>

                    <div className="form-group">
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={this.submitForm}
                      >
                        {isFetching ? <i className="fas fa-sync-alt fa-spin"></i> : null}{" "}
                        {this.props.t("regSuccessScr-get-started")}
                      </button>
                    </div>
                  </form>
                  <div className="form-group mb-40">
                    <button type="button" className="btn needhelp-label"
                      onClick={() => {
                        this.openHelpModal();
                      }}

                    >
                    {this.props.t("regNameScr-needHelp")}
                    </button>
                  </div>
                  <RegisterFooter />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

function mapStateToProps(state) {
  return {
    registeredPassword: state.userAccount.registeredPassword,
    registeredFirstname: state.userAccount.registeredFirstname,
    registeredLastname: state.userAccount.registeredLastname,
    isFetching: loadingSelector(state),
    completeRegisterUserResponse:
      state.userAccount.completeRegisterUserResponse,
    getUserInfoResponse: state.userAccount.getUserInfoResponse,
    error: state.userAccount.error,
    setHelpListData: state.userAccount.setHelpListData,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    doCompleteRegisterUser: (data) => dispatch(completeRegisterUser(data)),
    doCompleteRegisterUserClear: () => dispatch(completeRegisterUserClear()),
    doGetUserInformation: () => dispatch(getUserInformation()),
    getUserInfoClear: () => dispatch(getUserInfoClear()),
    doLoginRegisteredUser: (data) => dispatch(loginRegisteredUser(data)),

    dosetHelpList: (data) => dispatch(setHelpList(data)),
    doShowModal: (data) => dispatch(showModal(data)),
    doHideModal: () => dispatch(hideModal()),
  };
}
export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(RegisterSuccess)
);
